<template>
  <BModal
    v-model="showModal"
    title="Update App Type"
    centered
    no-footer
    size="lg"
    header-border-variant="primary"
    @hidden="close"
    @hide="hideModal"
  >
    <div class="modal-body p-0">
      <div class="row">
        <div class="col-12">
          <FormWithValidation
            :key="formKey"
            v-model="form"
            col-class="col-12"
            :initial-state="initialState"
            :validation-rules-function="() => getAppTypeFormRules(form)"
            :validation-messages="validationMessages"
            :field-labels-map="fieldLabelsMap"
            :saved-callback="submit"
          >
            <template #helpText="slotProps">
              <FormField
                id="helpText"
                name="helpText"
                label="Help Text"
                :mandatory="true"
                :v-field="slotProps.vForm.helpText"
                :validation-messages="slotProps.validationMessages.helpText"
                :field-errors="slotProps.fieldErrors"
                :class="slotProps.getIsInvalidClass(slotProps.vForm.helpText)"
              >
                <TextArea
                  id="helpText"
                  v-model="form.helpText"
                  rows="10"
                  :class="slotProps.getIsInvalidClass(slotProps.vForm.helpText)"
                  name="helpText"
                  class=""
                />
              </FormField>
            </template>

            <template #cancel-button>
              <StoreButton @click="close">
                <span>Cancel</span>
              </StoreButton>
            </template>
          </FormWithValidation>
        </div>
      </div>
    </div>
  </BModal>
</template>

<script lang="ts" setup>
import { BModal } from "bootstrap-vue-next";
import FormWithValidation from "~/components/shared/forms/FormWithValidation.vue";
import FormField from "~/components/shared/forms/FormField.vue";
import { useUiStore } from "~/stores/ui/uistore";
import StoreButton from "~/components/shared/buttons/StoreButton.vue";
import { reactive, ref, watch } from "vue";
import {
  type AppTypeForm,
  getAppTypeFormRules,
  validationMessages,
  fieldLabelsMap,
} from "~/validations/adminarea/app-type";
import TextArea from "~/components/shared/inputfields/TextArea.vue";

const props = defineProps({
  callbackFunction: { type: Function, required: true },
  appType: { type: Object, required: true },
});

const showModal = defineModel<boolean>({ default: false });
const formKey = ref(0);
function close() {
  showModal.value = false;
}

const initialState = reactive({
  helpText: props.appType.helpText || "",
});

const form = reactive<AppTypeForm>({
  ...initialState,
});

// Watch for app settings changes and update both form and initialState
watch(
  () => props.appType,
  (_unusedNewSettings) => {
    resetFromProps();
  },
  { immediate: true, deep: true },
);

const hideModal = () => {
  useUiStore().isFormDirty = false;
  formKey.value += 1;
};

const submit = async (): Promise<void> => {
  await props.callbackFunction(form);
  useUiStore().isFormDirty = false;
};

function resetFromProps() {
  const helpText = props.appType.helpText || "";
  // update both "initial" and "current" so dirty-checking is correct
  initialState.helpText = helpText;
  form.helpText = helpText;
  // reset validation state by remounting FormWithValidation
  formKey.value += 1;
}
</script>
<!-- scoped - does not work here because the bootstrap modal uses teleports -->
<style lang="scss"></style>
